import { useEffect, useRef } from "react";
import { WS_URL } from "./api";

export function useRealtime(onEvent) {
  const wsRef = useRef(null);
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    let alive = true;
    let retryTimer = null;

    function connect() {
      if (!WS_URL) return;
      try {
        const token = localStorage.getItem("mazboy_token");
        if (!token) return;
        const ws = new WebSocket(`${WS_URL}?token=${encodeURIComponent(token)}`);
        wsRef.current = ws;
        ws.onmessage = (e) => {
          try {
            const msg = JSON.parse(e.data);
            handlerRef.current?.(msg);
          } catch {}
        };
        ws.onclose = () => {
          if (alive) retryTimer = setTimeout(connect, 3000);
        };
        ws.onerror = () => ws.close();
      } catch {
        retryTimer = setTimeout(connect, 3000);
      }
    }
    connect();
    return () => {
      alive = false;
      if (retryTimer) clearTimeout(retryTimer);
      wsRef.current?.close();
    };
  }, []);
}
